import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import DesktopNavCategoryItem from '../DesktopNavCategoryItem';
const DesktopNavCategoriesUI = t0 => {
  const $ = _c(2);
  const {
    items: t1,
    selectedCategoryId,
    setIsLinkHovered
  } = t0;
  const items = t1 === undefined ? [] : t1;
  const containerRef = useRef(null);
  const t2 = "items-center flex justify-between m-0 p-0";
  const t4 = items.map(t3 => {
    const {
      color,
      id,
      label,
      url
    } = t3;
    return <DesktopNavCategoryItem color={color} containerRef={containerRef} id={id} isOpen={id === selectedCategoryId} key={id} label={label} setIsLinkHovered={setIsLinkHovered} url={url} />;
  });
  let t5;
  if ($[0] !== t4) {
    t5 = <ul className={t2} ref={containerRef}>{t4}</ul>;
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  return t5;
};
DesktopNavCategoriesUI.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })),
  selectedCategoryId: PropTypes.string,
  setIsLinkHovered: PropTypes.func
};
export default DesktopNavCategoriesUI;